{
  "R": [0, 0, 0],
  "G": [0, 128, 255],
  "B": [255, 196, 128],
  "A": [0, 64, 128],
  "I": [0, 128, 255]
}
